module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/tabination.component.scss
// module id = ./src/app/features/tabination/tabination.component.scss
// module chunks = main